import { FormattedMessage } from 'react-intl';
import messages from './messages';
import newTenantEventsMessages from '../NewTenantEvents/messages';
import { DEFAULT_APPROVED_AMOUNT_COLUMN_WIDTH } from '../constants';

export const HEADERS = [
  {
    id: 'headOfHousehold',
    label: <FormattedMessage {...messages.headOfHousehold} />,
    dataType: 'string',
    sortable: true,
    searchable: true,
  },
  {
    id: 'unit',
    label: <FormattedMessage {...messages.unit} />,
    dataType: 'string',
    sortable: true,
    searchable: true,
  },
  {
    id: 'hudUnitNumber',
    label: <FormattedMessage {...newTenantEventsMessages.hudUnitNumber} />,
    info: (
      <FormattedMessage {...newTenantEventsMessages.hudUnitNumberTooltip} />
    ),
    dataType: 'string',
    sortable: true,
    searchable: true,
  },
  {
    id: 'agreementId',
    label: <FormattedMessage {...messages.agreementId} />,
    dataType: 'string',
    sortable: true,
    searchable: true,
  },
  {
    id: 'agreementDate',
    label: <FormattedMessage {...messages.agreementDate} />,
    dataType: 'date',
    sortable: true,
    searchable: true,
  },
  {
    id: 'agreementType',
    label: <FormattedMessage {...messages.agreementType} />,
    dataType: 'string',
    sortable: true,
    searchable: true,
    multiselect: true,
  },
  {
    id: 'agreementAmount',
    label: <FormattedMessage {...messages.agreementAmount} />,
    dataType: 'number',
    sortable: true,
    searchable: true,
  },
  {
    id: 'agreementChangeAmount',
    label: <FormattedMessage {...messages.agreementChangeAmount} />,
    dataType: 'number',
    sortable: true,
    searchable: true,
  },
  {
    id: 'totalPayment',
    label: <FormattedMessage {...messages.totalPayment} />,
    dataType: 'number',
    sortable: true,
    searchable: true,
  },
  {
    id: 'endingBalance',
    label: <FormattedMessage {...messages.endingBalance} />,
    dataType: 'number',
    sortable: true,
    searchable: true,
  },
  {
    id: 'amountRetained',
    label: <FormattedMessage {...messages.amountRetained} />,
    dataType: 'number',
    sortable: true,
    searchable: true,
  },
  {
    id: 'requestedAmount',
    label: <FormattedMessage {...messages.requestedAmount} />,
    dataType: 'number',
    sortable: true,
    searchable: true,
  },
  {
    id: 'approvedAmount',
    label: <FormattedMessage {...messages.approvedAmount} />,
    dataType: 'number',
    defaultWidth: DEFAULT_APPROVED_AMOUNT_COLUMN_WIDTH,
    sortable: true,
    searchable: true,
  },
  {
    id: 'actions',
    label: <FormattedMessage {...messages.actions} />,
  },
];

export const PROPERTY_PATH_MAP = {
  unit: {
    path: 'unit',
    dataType: 'string',
  },
  hudUnitNumber: {
    path: 'hudUnitNumber',
    dataType: 'string',
  },
  headOfHousehold: {
    path: 'headOfHousehold',
    dataType: 'string',
  },
  agreementId: {
    path: 'agreementId',
    dataType: 'string',
  },
  agreementType: {
    path: 'agreementTypeSearch',
    filterPath: 'agreementType',
    dataType: 'string',
  },
  agreementDate: {
    path: 'agreementDate',
    dataType: 'date',
  },
  agreementAmount: {
    path: 'agreementAmount',
    dataType: 'number',
  },
  endingBalance: {
    path: 'endingBalance',
    dataType: 'number',
  },
  amountRetained: {
    path: 'amountRetained',
    dataType: 'number',
  },
  requestedAmount: {
    path: 'requestedAmount',
    dataType: 'number',
  },
  approvedAmount: {
    path: 'approvedAmount',
    dataType: 'number',
  },
  agreementBalance: {
    path: 'agreementBalance',
    dataType: 'number',
  },
  agreementChangeAmount: {
    path: 'agreementChangeAmount',
    dataType: 'number',
  },
  totalPayment: {
    path: 'totalPayment',
    dataType: 'number',
  },
  paymentsRemaining: {
    path: 'paymentsRemaining',
    dataType: 'number',
  },
  tracsMessage: {
    path: 'tracsMessage',
    dataType: 'string',
  },
  actions: {
    path: 'actions',
    dataType: 'string',
  },
};

export const AGREEMENT_TYPE_OPTIONS = [
  { value: 'T', text: 'T - Tenant' },
  { value: 'O', text: 'O - Owner' },
  { value: 'N', text: 'N - None' },
];

export const NEW_OR_ONGOING_OPTIONS = [
  { value: 'NEW', text: 'New' },
  { value: 'ONGOING', text: 'Ongoing' },
];

export const HOUSEHOLD_STATUS_OPTIONS = [
  { value: 'CURRENT_RESIDENT', text: 'Current Resident' },
  { value: 'PRIOR_RESIDENT', text: 'Prior Resident' },
];
